import { PetInfo } from '@app/core/models';
import { selectBreeds } from '@app/store/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { smartRecoFeatureKey } from '../smart-reco-feature-key';
import { SmartRecoState } from '../smart-reco.state';
import { selectPathologies } from './smart-reco-patient.selectors';
import { getIbwFromBcsAndLifeStage } from '@app/shared/utils/static-helpers/rationing-helper';
import { selectProfile, selectWeight } from '@app/store/patient-profile/patient-profile.selectors';

const selectState = createFeatureSelector<SmartRecoState>(smartRecoFeatureKey);

export const selectSteps = createSelector(selectState, (state) => state.steps);
export const selectStep = createSelector(selectState, (state) => state.step);
export const selectLastStep = createSelector(selectState, (state) => state.lastStepBeforeAllowance);

/**
 * Deprecated pet info selector for old components compatibilty
 */
export const selectSmartRecoPetSummary = createSelector(
  selectProfile,
  selectWeight,
  selectPathologies,
  selectBreeds,
  (profile, weight, pathologies, breeds) => {
    return (
      !!profile &&
      <PetInfo>{
        ...profile,
        breedObject: breeds?.find((b) => b.breedCode === profile.breed),
        bcs: weight?.bcs,
        weight: weight?.currentWeight,
        targetWeight: weight?.targetWeight,
        IBW: getIbwFromBcsAndLifeStage(weight, profile),
        petActivity: weight?.petActivity,
        pathologies: pathologies.filter((p) => !p.isRiskFactor).map((p) => p.value),
        sensitivities: pathologies.filter((p) => p.isRiskFactor).map((p) => p.value),
      }
    );
  },
);
